import React, { useContext, useState, useEffect } from 'react'
import Image from 'next/image'
import ProfileContext from '@/components/Context/ProfileContext'

const AeliaStoreBandeau: React.FC = () => {
  const { profile } = useContext(ProfileContext)
  const [closingDate, setClosingDate] = useState<string>('')

  useEffect(() => {
    const calculateClosingDate = () => {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // Normaliser à minuit pour la comparaison
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth()

      // Fonction pour trouver le dimanche après le 15 d'un mois donné
      const getSundayAfter15 = (year: number, month: number): Date => {
        const sunday = new Date(year, month, 16)
        while (sunday.getDay() !== 0) {
          sunday.setDate(sunday.getDate() + 1)
        }
        return sunday
      }

      // Calculer le dimanche après le 15 du mois courant
      const currentMonthSunday = getSundayAfter15(currentYear, currentMonth)

      // Si aujourd'hui est APRÈS le dimanche de clôture du mois courant, on passe au mois prochain
      // On affiche la date du mois courant jusqu'au lundi inclus (lendemain du dimanche)
      const dayAfterSunday = new Date(currentMonthSunday)
      dayAfterSunday.setDate(dayAfterSunday.getDate() + 1)

      // Si aujourd'hui est après le lundi, on passe au mois prochain, sinon on reste sur le mois courant
      const sunday: Date = today > dayAfterSunday
        ? getSundayAfter15(
            currentMonth + 1 > 11 ? currentYear + 1 : currentYear,
            currentMonth + 1 > 11 ? 0 : currentMonth + 1
          )
        : currentMonthSunday

      // Formater la date en français
      const options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      const formattedDate = sunday.toLocaleDateString('fr-FR', options)

      setClosingDate(formattedDate)
    }

    calculateClosingDate()
  }, [])

  if (!profile.groupAeliaStore) {
    return null
  }

  return (
    <div
      className="text-white py-1 px-4 flex items-center justify-center rounded-sm"
      style={{ backgroundColor: '#EA4B6B' }}
    >
      <div className="flex items-center gap-3">
        <Image src="/images/Icon-Info.svg" alt="Info" width={24} height={24} />
        <span className="text-sm font-bold">Prochaine date de clôture des commandes</span>
        <div
          className="bg-white border-2 rounded-full px-4 py-1"
          style={{ borderColor: '#EA4B6B' }}
        >
          <span className="font-bold text-sm" style={{ color: '#EA4B6B' }}>
            {closingDate}
          </span>
        </div>
      </div>
    </div>
  )
}

export default AeliaStoreBandeau
